/**
 * About — factual overview of The Scorekeeper platform.
 */
export function AboutPage() {
  return (
    <article className="m-article">
      <div className="eyebrow">About</div>
      <h1 className="h1">The Scorekeeper</h1>
      <p className="lede">
        Tournament and league management software built for roller hockey.
      </p>

      <h2 className="h2" style={{ marginTop: 32 }}>What it does</h2>
      <ul className="m-bullets">
        <li>Tournament and season scheduling with conflict detection</li>
        <li>Team and player registration with roster management</li>
        <li>Live scoring, standings, and game recaps</li>
        <li>Crew assignment — scorekeepers and referees — for every game</li>
        <li>Communications to players, captains, coaches, and staff</li>
        <li>AI-generated scouting reports and post-game recaps</li>
        <li>Player stats, performance trends, and leaderboards</li>
      </ul>

      <h2 className="h2" style={{ marginTop: 32 }}>Who it's for</h2>
      <ul className="m-bullets">
        <li><strong>League commissioners</strong> — create and publish events, manage divisions, send communications</li>
        <li><strong>Team captains</strong> — manage rosters, view schedules, track standings</li>
        <li><strong>Players</strong> — personal stats, schedule, team page</li>
        <li><strong>Fans</strong> — live scores and standings at the rink or from home</li>
      </ul>

      <h2 className="h2" style={{ marginTop: 32 }}>Contact</h2>
      <p>
        <a href="mailto:datasciconsulting@gmail.com">datasciconsulting@gmail.com</a>
      </p>
    </article>
  );
}
